import { render, staticRenderFns } from "./social-rating.vue?vue&type=template&id=b9b53c3e&lang=pug&"
import script from "./social-rating.vue?vue&type=script&lang=js&"
export * from "./social-rating.vue?vue&type=script&lang=js&"
import style0 from "./social-rating.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports